import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import { APIHandler, Email, Register, StorageHandler, Forgot } from 'C4';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidity = () =>
  Array.from(document.getElementsByTagName('input')).every(val => val.checkValidity() === true);

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

let lang = localStorage.getItem('lang');
if (lang) {
  lang = JSON.parse(lang);
  lang = lang.rawData;
} else {
  lang = '';
}

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: {
        email: '',
        reg_category: '',
        reg_email: '',
        reg_password: '',
        reg_confirmPassword: '',
        reg_first_name: '',
        reg_last_name: '',
        reg_zipcode: '',
        reg_country: lang.country,
        reg_state: '',
        marketing_opt_in: false,
        reg_agency_affiliation: '',
      },
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
        loadingAnimForgot: false,
      },
      message: '',
      redirect: '',
      admission_message: '',
      verified_message: '',
      resend_link: '',
      userExists: null,
    };

    document.body.classList.add('no-scroll');

    this.changeHandler = this.changeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.userExistsHandler = this.userExistsHandler.bind(this);
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  async componentDidMount() {
    const { path } = this.props;
    await this.checkRedirect();
    if (path === '/logout') {
      StorageHandler.remove(storageKeys.lang);
    }
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    const el = document.querySelector('.form__message');
    el.style.opacity = 1;
    el.style.color = 'black';
  }

  async checkRedirect() {
    const { path } = this.props;
    const userExists = await StorageHandler.exists(storageKeys.user);
    if (path !== '/logout' && userExists) {
      // Login to register with everything filled in TODO
      // this.setState({ redirect: '/login/register' });
    } else {
      StorageHandler.removeKeys(userKeys);
      if (path !== '/login') {
        this.setState({ redirect: '/login' });
      }
    }
  }

  backHandler() {
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  userExistsHandler(boolean) {
    this.setState({ userExists: boolean });
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value;
    this.setState({ userInput: input });
  }

  async resendHandler() {
    await APIHandler.resendVerificationLink(this.state.resend_link).then((res) => {
      if (res.success) {
        toast.success(res.message, {
          position: 'bottom-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ resend_link: '' });
      }
    });
  }

  forgotHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { email } = this.state.userInput;
    const { pathname } = window.location;
    this.setAnim('loadingAnimForgot', true);
    APIHandler.forgotPassword(email).then((res) => {
      if (res.status !== 200) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error("The email address you entered doesn't exist.", {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.success(res.message.concat('\n You will be redirected to the login page in 10 seconds'), {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        if (pathname === '/login/forgot-mobile') {
          window.setTimeout(() => {
            window.postMessage('exit');
            window.ReactNativeWebView.postMessage('exit');
          }, 5000);
          return;
        }
        window.setTimeout(() => {
          window.location.href = '/login';
        }, 10000);
      }
    });
  }

  render() {
    const {
      animation, message, redirect, userInput, userExists,
    } = this.state;

    const { pathname } = window.location;

    return (
      <form className="login__form">
        {pathname === '/login' && (
          <Email
            change={this.changeHandler}
            checkInputValidity={checkInputValidity}
            loadingAnim={animation.loadingAnim}
            setAnim={this.setAnim}
            userExists={userExists}
            userExistsHandler={this.userExistsHandler}
            userInput={userInput}
          />
        )}

        {(pathname === '/login/forgot' ||
          pathname === '/login/forgot-mobile') && (
          <Forgot
            back={this.backHandler}
            change={this.changeHandler}
            defaultVal={userInput.email}
            loadingAnimRegister={animation.loadingAnimForgot}
            setAnim={this.setAnim}
            submit={this.forgotHandler}
          />
        )}

        {(pathname === '/login/register' ||
          pathname === '/login/register-mobile' || 
          pathname === '/login/register-mobile-exist' ||
          pathname === '/login/quick-register') && <Register />}

        {message && <h3 className="form__message">{message}</h3>}

        {(pathname === '/login/register-mobile' || pathname === '/login/forgot-mobile' || pathname === '/login/forgot-mobile-exist') && (
          <style>
            {
              '\
          .cookieConsent { display: none; bottom: 4rem; } #openWidget { display: none !important; }'
            }
          </style>
        )}

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <SweetAlert
          html
          title=""
          onConfirm={() => {
            this.setState({ admission_message: '' });
          }}
          show={!!this.state.admission_message}
          confirmButtonText="Ok"
          text={this.state.admission_message}
        />
        <SweetAlert
          html
          title="Email not Verified:"
          onConfirm={() => {
            this.setState({ verified_message: '' });
          }}
          onCancel={() => {
            this.setState({ verified_message: '' });
            this.resendHandler();
          }}
          show={!!this.state.verified_message}
          confirmButtonText="Ok"
          cancelButtonText="Resend email"
          showCancelButton
          text={this.state.verified_message}
        />
        <ToastContainer
          draggablePercent={70}
        />
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
